var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox-group',{model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},_vm._l((_vm.state),function(item,key){return _c('el-checkbox',{key:key,attrs:{"label":item.value}},[_vm._v(_vm._s(item.label))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }